import { Backlog, BacklogStatus } from '@prisma/client';

import { prettyDate } from '../formatter';

type SanitizedBacklog = Pick<
  Backlog,
  'provider_id' | 'airport_id' | 'status' | 'id' | 'starts_at' | 'expires_at' | 'next_flight_at'
>;

export const getBacklogStatus = (backlogs?: SanitizedBacklog[]) => {
  if (!backlogs?.length) return null;
  const atRisk = backlogs.find((b) => b.status === BacklogStatus.AtRisk);
  const backlogged = backlogs.find((b) => b.status === BacklogStatus.Backlogged);

  if (backlogged && backlogged.next_flight_at) {
    return `Backlogged until ${prettyDate(backlogged.next_flight_at)}`;
  }
  if (backlogged) {
    return 'Backlogged';
  }
  if (atRisk) {
    return `Backlog Risk`;
  }
  return null;
};
